(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-hero-banner"] && !Shopify.designMode) return;
  try {
    
/* No JS needed – purely CSS/responsive */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-image-banner"] && !Shopify.designMode) return;
  try {
    
/* No JS required – layout handled with CSS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-blog"] && !Shopify.designMode) return;
  try {
    
(function() {
  const section = document.currentScript.closest('section');
  if (!section) return;

  const input = section.querySelector('[data-blog-search]');
  const cards = section.querySelectorAll('[data-blog-card]');

  if (!input || !cards.length) return;

  input.addEventListener('input', function() {
    const q = (this.value || '').trim().toLowerCase();

    cards.forEach(card => {
      const hay = (card.getAttribute('data-search') || '').toLowerCase();
      card.style.display = hay.includes(q) ? '' : 'none';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Handle ALL faq sections on the page
  var faqSections = document.querySelectorAll('.faq-section');
  if (!faqSections.length) return;

  faqSections.forEach(function (section) {
    var items = section.querySelectorAll('.faq-item');

    items.forEach(function (item) {
      var btn = item.querySelector('.faq-item__question');
      var answerWrap = item.querySelector('.faq-item__answer-wrapper');

      if (!btn || !answerWrap) return;

      // start collapsed
      answerWrap.style.maxHeight = '0px';

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('faq-item--open');

        // close all others in this section
        items.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('faq-item--open');
            var otherWrap = other.querySelector('.faq-item__answer-wrapper');
            var otherBtn = other.querySelector('.faq-item__question');
            if (otherWrap) otherWrap.style.maxHeight = '0px';
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          }
        });

        if (isOpen) {
          item.classList.remove('faq-item--open');
          answerWrap.style.maxHeight = '0px';
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('faq-item--open');
          answerWrap.style.maxHeight = answerWrap.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filter-product-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  // Only wire up THIS instance of the section
  const section = document.querySelector('.filter-grid-section[data-filter-section="{{ section.id }}"]');
  if (!section) return;

  const filterButtons = section.querySelectorAll(".filter-option");
  const cards = section.querySelectorAll(".product-card");

  // Helper: check if a product card has a particular tag
  function cardHasTag(card, filter) {
    const rawTags = (card.dataset.tags || "").toLowerCase().split(",");
    return rawTags.some(tag => tag.trim() === filter || tag.trim().includes(filter));
  }

  function applyFilter(filter) {
    // Special case: 'all' shows everything
    if (filter === "all") {
      cards.forEach(card => {
        card.style.display = "";
        card.classList.add("show");
      });
      return;
    }

    cards.forEach(card => {
      if (cardHasTag(card, filter)) {
        card.style.display = "";
        card.classList.add("show");
      } else {
        card.style.display = "none";
        card.classList.remove("show");
      }
    });
  }

  // Button clicks
  filterButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      const filter = (btn.dataset.filter || "").toLowerCase();

      // reset active
      filterButtons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      applyFilter(filter);
    });
  });

  // Initial: show all
  cards.forEach(card => card.classList.add("show"));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-use-steps"] && !Shopify.designMode) return;
  try {
    
/* No JS needed – layout is pure CSS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.ingredients-section[data-section-id="{{ section.id }}"]');
  if (!section) return;

  const track = section.querySelector('.ingredients-slider__track');
  const prevBtn = section.querySelector('.ingredients-slider__arrow--prev');
  const nextBtn = section.querySelector('.ingredients-slider__arrow--next');

  if (!track || !prevBtn || !nextBtn) return;

  function updateArrows() {
    const maxScroll = track.scrollWidth - track.clientWidth;
    prevBtn.classList.toggle('ingredients-slider__arrow--disabled', track.scrollLeft <= 5);
    nextBtn.classList.toggle('ingredients-slider__arrow--disabled', track.scrollLeft >= maxScroll - 5);
  }

  prevBtn.addEventListener('click', () => {
    track.scrollBy({ left: -track.clientWidth * 0.85, behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', () => {
    track.scrollBy({ left: track.clientWidth * 0.85, behavior: 'smooth' });
  });

  track.addEventListener('scroll', updateArrows);
  window.addEventListener('resize', updateArrows);
  updateArrows();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-production"] && !Shopify.designMode) return;
  try {
    
/* No JavaScript needed – hover and layout handled with CSS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-review-form"] && !Shopify.designMode) return;
  try {
    
/* No JS required – stars & layout are handled with CSS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sourcing-process"] && !Shopify.designMode) return;
  try {
    
/* No JS needed – layout is responsive with CSS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-mission"] && !Shopify.designMode) return;
  try {
    
/* No JS needed – layout is fully responsive with CSS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.testimonial-section').forEach(function(section) {
    const slider = section.querySelector('.testimonial-slider');
    const track = section.querySelector('.testimonial-slider-track');
    const prevBtn = section.querySelector('.testimonial-arrow-prev');
    const nextBtn = section.querySelector('.testimonial-arrow-next');

    if (!slider || !track || !prevBtn || !nextBtn) return;

    function getScrollAmount() {
      // Scroll by exactly the visible area (so 3→next 3, etc.)
      return slider.clientWidth;
    }

    function updateArrows() {
      const maxScroll = track.scrollWidth - slider.clientWidth;
      if (slider.scrollLeft <= 0) {
        prevBtn.disabled = true;
      } else {
        prevBtn.disabled = false;
      }
      if (slider.scrollLeft >= maxScroll - 1) {
        nextBtn.disabled = true;
      } else {
        nextBtn.disabled = false;
      }
    }

    prevBtn.addEventListener('click', function() {
      slider.scrollTo({
        left: Math.max(slider.scrollLeft - getScrollAmount(), 0),
        behavior: 'smooth'
      });
      setTimeout(updateArrows, 400);
    });

    nextBtn.addEventListener('click', function() {
      const maxScroll = track.scrollWidth - slider.clientWidth;
      slider.scrollTo({
        left: Math.min(slider.scrollLeft + getScrollAmount(), maxScroll),
        behavior: 'smooth'
      });
      setTimeout(updateArrows, 400);
    });

    // Initial state
    updateArrows();

    // Recalculate on resize
    window.addEventListener('resize', function() {
      setTimeout(updateArrows, 300);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-shrisiddh"] && !Shopify.designMode) return;
  try {
    
/* No JS needed – layout is pure CSS */

  } catch(e) { console.error(e); }
})();
})();
